<template>
  <div id="EDSREquest">
    <Subtitle v-bind:ServiceID="this.AppServiceID">
      <template v-slot:header>
        <i class="fa fa-user-md"></i><b>New EDS Request:</b>
      </template>
    </Subtitle>
    <b-modal id="modal-sm" size="md" title="EDS Request Error" v-model="showError" no-close-on-esc no-close-on-backdrop
      hide-header-close>
      <div slot="default">
        <div class="alert alert-warning" role="alert">{{ MsgPopup }}</div>
      </div>
      <div slot="modal-footer" class="w-100">
        <p class="float-left" variant="primary"></p>
        <b-button variant="primary" size="md" class="float-right" @click="ClosePopup">
          Close
        </b-button>
      </div>
    </b-modal>

    <form class="card  p-0 mb-1 m-2" id="SearchForm">
      <div class="card-header d-flex align-items-center  m-1" style="height: 1rem; text-align:left;">
        <h5>
          <small class="text-muted"><b><i class="fas fa-search-plus"></i>Search: HSN and EDS Drug</b></small>
        </h5>
      </div>
      <!-- {{ msdpUser }} -->
      <div class="form-row m-1" id="SearchBox">
        <div class="form-group col-sm-1">
          <label for="inputEmail4" class="label-small">HSN</label>
          <input id="hsntxt" @input="HSNtextChanged" v-model="HSN" maxlength="9" class="form-control form-control-xs" />
          <div class="row" v-show="$v.HSN.$error">
            <div class="col-sm-12">
              <small class="sml-red" v-if="!$v.HSN.required">HSN is required.</small>
            </div>
          </div>
          <div class="row" v-show="$v.HSN.$error">
            <div class="col-sm-12">
              <small class="sml-red" v-if="!$v.HSN.minLength">Minimum 9 digit required.</small>
            </div>
          </div>
          <div class="row" v-show="$v.HSN.$error">
            <div class="col-sm-12">
              <small class="sml-red" v-if="!$v.HSN.numeric">HSN must be a number.</small>
            </div>
          </div>
        </div>
        <!-- <div class="form-group col-sm-1">
        <label for="inputPassword4" class="label-small">From Date</label>
        <div>
            <datepicker class="servdatapick"  :open-date="new Date()" v-model="fromDate" 
              :format="DateFormat" id="effDate" :bootstrap-styling="true" :input-class="datapickClass"
              name="fromDatepicker"></datepicker>
        </div> 
        <div  class="row" v-show="$v.fromDate.$error">
          <div class="col-sm-12"> 
              <small class="sml-red" v-if="!$v.fromDate.needValue">Valid from date is required.</small>
         </div> 
        </div>
      </div>
      <div class="form-group col-sm-1">
        <label for="inputPassword4" class="label-small">To Date:</label>
        <div>
              <datepicker class="servdatapick"  :open-date="new Date()" v-model="toDate" :format="DateFormat" 
                id="toDate" :bootstrap-styling="true" :input-class="datapickClass" name="toDatepicker"></datepicker>
        </div>
        <div  class="row" v-show="$v.toDate.$error">
             <div class="col-sm-12"> 
              <small class="sml-red" v-if="!$v.toDate.needValue">Valid to date is required.</small>
             </div> 
        </div>
      </div> -->

        <!-- {{ selectedEds }} -->
        <!-- <hr> -->
<!-- {{CriteriaSelected }} -->
        <!-- {{ pharmaFname }} -->
        <div class="form-group col-sm-4">
          <label for="inputPassword4" class="label-small">Search EDS Drug:</label>
          <div class="col-sm-12 m-0 pr-3 pl-0">
            <vue-bootstrap-typeahead :inputClass="TypeHeadinptClass" id="edssel" ref="clinicRef" @input="EdsChanged"
              v-model="edsdosage" :data="Eds" @hit="
      selectedEds = $event;
    searched = false;
    " :serializer="(item) => item.eds + ' | ' + item.dosage" textVariant=".text-primary"
              placeholder="Search generic name" size="sm" backgroundVariant="bg-light" :maxMatches="20"
              updateOn="blur">
              <template slot="prepend">
                <span class="input-group-text form-control-xs" style="font-size: .7rem;"><i
                    class="fas fa-search fa-sm"></i></span>
              </template>
            </vue-bootstrap-typeahead>
            <div class="row" v-show="$v.selectedEds.$error">
            <div class="col-sm-12">
              <small class="sml-red" v-if="!$v.selectedEds.required">Select Eds Drug.</small>
            </div>
          </div>
          </div>
        </div>
        <div class="form-group col-sm-4">
          <label for="inputPassword4" class="label-small">Search Prescriber:</label>
          <div class="col-sm-12 m-0 pr-3 pl-0">
            <vue-bootstrap-typeahead :disabled="DisbleProvider" :inputClass="TypeHeadinptClass" id="provSel"
              ref="providerRef" @input="ProvidertextChanged" v-model="providerName" :data="providers" @hit="
      selectedProvider = $event;
    searched = false;
    " :serializer="(item) => item.providername" textVariant=".text-primary"
              placeholder="Type Prescriber name" size="sm" backgroundVariant="bg-light" :maxMatches="20">
              <template slot="prepend">
                <span class="input-group-text form-control-xs" style="font-size: .7rem;"><i
                    class="fas fa-search fa-sm"></i></span>
              </template>
            </vue-bootstrap-typeahead>
            <div class="row" v-show="$v.selectedProvider.$error">
            <div class="col-sm-12">
              <small class="sml-red" v-if="!$v.selectedProvider.required">Select Provider.</small>
            </div>
          </div>
          </div>
        </div>
        <!-- {{ selectedProvider }} -->
        <div class="form-group col-sm-1">
          <label for="inputPassword4" class="label-small"> </label>
          <div class=" ">
            <button
              :disabled="HSN.length == 0 || selectedProvider == '' || selectedProvider == null || selectedEds == '' || selectedEds == null"
              v-on:click="GetHsnInfo" type="button" class="btn btn-primary btn-sml mt-1">
              Search
            </button>
          </div>
        </div>
      </div>
    </form>
    <!-- {{ patient }} -->
    <div class="row no-gutters m-2">
      <div class="col-6 pr-1" v-if="patient != null">
        <div class="card pb-1">
          <div class="card-header d-flex align-items-center  pl-1" style="height: 1rem; text-align:left;">
            <h5>
              <small class="text-muted"><b><i class="fas fa-user-injured"></i>Patient:
                  {{ patient.firstName }} {{ patient.lastName }} ( Age: {{ patient.age }})
                </b></small>
            </h5>
          </div>
          <div class="card-body p-1">
            <div class="row">
              <span for="cname" class="col-sm-4"><b class="label-small">HSN:</b></span>
              <span class="col-sm-6 label-small" type="text">{{ HSN }}</span>
            </div>
            <div class="row">
              <span for="cname" class="col-sm-4"><b class="label-small">Address:</b></span>
              <span class="col-sm-6 label-small" type="text">
                {{ patient.address1 }} {{ patient.address2 }}
              </span>
            </div>
            <div class="row">
              <span for="cname" class="col-sm-4"><b class="label-small">DOB:</b></span>
              <span class="col-sm-6 label-small" type="text">{{ patient.birthDay | moment(patient.birthDay) }}
              </span>
            </div>
            <!-- <div class="row">
              <span for="cname" class="col-sm-4"><b class="label-small">Age:</b></span>
              <span class="col-sm-6 label-small" type="text">{{ patient.age }}
              </span>
            </div> -->
          </div>
        </div>
      </div>
      <div class="col-6 pr-0" v-if="selectedProvider != null && patient != null">
        <div class="card pb-1">
          <div class="card-header d-flex align-items-center  pl-1" style="height: 1rem; text-align:left;">
            <h5 v-if="selectedProvider.providername.length < 25">
              <small class="text-muted"><b><i class="fas fa-clinic-medical"></i>Prescriber:
                  {{ selectedProvider.providername }}</b></small>
            </h5>
            <h5 v-else style="font-size: 90%;">
              <small class="text-muted"><b><i class="fas fa-clinic-medical"></i>Prescriber:
                  {{ selectedProvider.providername }}</b></small>
            </h5>
          </div>
          <div class="card-body p-1">
            <div class="row">
              <span for="cname" class="col-sm-3"><b class="label-small">Prescriber #:</b></span>
              <span class="col-sm-9 label-small" type="text">{{ selectedProvider.orgid
                }}{{ selectedProvider.providerno }}</span>
            </div>
            <div class="row">
              <span for="cname" class="col-sm-3"><b class="label-small">Address:</b></span>
              <span class="col-sm-9 label-small" type="text">{{
      selectedProvider.address
    }}</span>
            </div>
            <div class="row">
              <span for="cname" class="col-sm-3"><b class="label-small">City:</b></span>
              <span class="col-sm-9 label-small" type="text">{{
        selectedProvider.city
      }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <form v-if="Criteria.length > 0 && selectedEds !== null" class="card  p-0 m-2" id="SearchForm">
      <div class="card-header d-flex align-items-center  m-1" style="height: 2rem; text-align:left;">
        <h4>
          <small class="text-muted"><b><i class="fas fa-clinic-medical"></i>Choose Criteria for :
              {{ selectedEds.eds + " | " + selectedEds.dosage }}</b></small>
        </h4>
      </div>

      <!-- <div class="" id="CriteriaBox">
        <div role="radio-group" class="bv-no-focus-ring">
            <div class="custom-control custom-radio b-custom-control-md" v-for="Splans in SailPlans" :key="Splans.id">
              <input type="radio" :id="Splans"  class=""  v-model="SAILPlansSelected" :name="Splans" :value="Splans">
                <label class="pointer" :for="Splans">{{ Splans.text }}</label> 
            </div>
          </div>  

          <span class="col-12 row ml-3" v-for="Splans in SailPlans" :key="Splans.id">
               <input type="radio" :id="Splans"  class="pointer mr-2"  v-model="SAILPlansSelected" :name="Splans" :value="Splans">
                <label class="pointer" :for="Splans">{{ Splans.text }}</label> 
               </span> 
      </div> -->
       <!-- {{ CriteriaSelected }} -->
      <div class="m-3 row d-flex">
        <b-form-radio-group  stacked size="lg" aria-invalid="false" v-model="CriteriaSelected" class="col-12">
          <b-form-radio v-for="plan in Criteria"    
             :value="plan" :key="plan.criteriaid">
             <!-- {{plan.criteria}} -->
             <div v-html="plan.criteria" class="pre-formatted"></div>
            <hr />
          </b-form-radio>
        </b-form-radio-group>

        <!-- <b-form-radio-group stacked size="md" aria-invalid="false"   @change="radiochange($event)" v-model="SAILPlansSelected" :options="SailPlans"   text-field="text" value-field="id" name="Criteria-radio"></b-form-radio-group> -->
        <!-- <b-form-radio v-model="SAILPlansSelected" :aria-describedby="ariaDescribedby" name="some-radios" value="B">Option B</b-form-radio> -->

        <!-- <div class="mt-3">Selected: <strong>{{ SAILPlansSelected }}</strong></div> -->
      </div>


      <transition name="slide-fade">
        <div class="form-row p-3 ml-5 " id="Box" v-if="showdates">
        <!-- <div class="form-row p-1 ml-1" id="Box"> -->
          <div class="form-group col-sm-3">
            <label for="inputPassword4" class="labelbg">Effective Date</label>
            <div>
              <!-- <datepicker class="servdatapick" :disabledDates="disableEffecDate" :open-date="openEffectDate"
                v-model="fromDate" :format="DateFormat" id="effDate" :bootstrap-styling="true"
                :input-class="datapickClass" name="fromDatepicker"></datepicker> -->

                <datepicker class="servdatapick labelbg" :disabled="disableEffCal" :disabledDates="disableEffecDate" :open-date="openEffectDate"
                v-model="fromDate" :format="DateFormat" id="effDate" :bootstrap-styling="true"
                :input-class="datapickClass" name="fromDatepicker"></datepicker>

            </div>
            <div class="row" v-show="$v.fromDate.$error">
              <div class="col-sm-12">
                <small class="sml-red" v-if="!$v.fromDate.needValue">Valid from date is required.</small>
              </div>
            </div>
          </div>
          <div class="form-group col-sm-3" v-show="false"
            v-if="this.CriteriaSelected != null && this.CriteriaSelected.allowexpedit == true">
            <label for="inputPassword4" class="label-small">{{ EditableUnit }}</label>
            <div>
              <input id="EditableLen" type="number" :disabled="!this.CriteriaSelected.allowexpedit" v-model="EditableLength"
                class="form-control form-control-xs" />
            </div>
            <!-- <div class="row" v-show="$v.toDate.$error">
              <div class="col-sm-12">
                <small class="sml-red" v-if="!$v.toDate.needValue"
                  >Valid to date is required.</small
                >
              </div>
            </div> -->
          </div>

          <div class="form-group col-sm-3">
            <label for="inputPassword4" class="labelbg">Expiry Date:</label>
            <div>
              <datepicker class="servdatapick" :disabled="disableExpCal" :disabledDates="disableExpDate" :open-date="openExpDate" v-model="toDate"
                :format="DateFormat" id="toDate" :bootstrap-styling="true" :input-class="datapickClass"
                name="toDatepicker">
              </datepicker>
            </div>
            <div class="row" v-show="$v.toDate.$error">
              <div class="col-sm-12">
                <small class="sml-red" v-if="!$v.toDate.needValue">Valid to date is required.</small>
              </div>
            </div>
          </div>
        </div>
      </transition>


      <div class="form-row m-2" id="Box" v-if="(Criteria !== null || Criteria !== '') &&
      CriteriaSelected != null && CriteriaSelected.commentallow != 'N'">

        <div class="form-group col-sm-12">
          <label for="inputPassword4" class="label-small">Comments</label>
          <div>
            <textarea wrap="on" maxlength="63" rows="2" max="300" id="Comments" type="textarea" v-model="Comments"
              placeholder="Add Comments" class="my-0 form-control text-area-xs"></textarea>
              <span v-if="Comments.length"> {{ Comments.length }}/63</span>
          </div>

          <div class="row" v-show="$v.Comments.$error">
            <div class="col-sm-12">
              <small class="sml-red" v-if="!$v.Comments.required">Comments are required.</small>
            </div>
          </div>
        </div>
      </div>

      <!-- {{ disableEffecDate}} -->
      <!-- {{fromDate}}}

      {{ openEffectDate }} -->
      <!-- {{ disableEffecDate}}

 open {{ openEffectDate }} -->

     <hr />
  
      <div class="row mb-5" v-if="CriteriaSelected !==null">
        <div class="col-sm-1"></div>
        <div class="col-sm-8">
          <div class="card">
            <div class="card-body">
              <h5 class="card-header">
                <b>
                  <i class="fa fa-server" aria-hidden="true"></i>DECLARATION: Confirmation and Verification of Criteria
                </b>
              </h5>
              <span class="card-text">
                <div class="form-group row my-1 no-gutter">
                  <label for="pharma" class="col-sm-4 label-small my-0">{{ DisAuthuser }}</label>
                  <div class="col-sm-4 my-0">
                    <input type="text" :disabled="msdpUser.length>0" maxlength="7" class="form-control form-control-sm" id="pharma" placeholder="License Number"
                      v-model="pharmaLicense">
                  </div>
                  <div class="row" v-show="$v.pharmaLicense.$error">
                  <div class="col-sm-12">
                    <small class="sml-red" v-if="!$v.pharmaLicense.required">This field is required.</small>
                  </div>
                </div>
                </div> 
                <div class="form-group row my-1  no-gutter">
                  <label for="pharmaname" class="col-sm-4 label-small my-0">{{DisName}}</label>
                  <div class="col-sm-4 my-0">
                    <input type="text" maxlength="25" :disabled="msdpUser.length>0" class="form-control form-control-sm" id="pharmaname" placeholder="First Name"
                      v-model="pharmaFname">
                      <div class="row" v-show="$v.pharmaFname.$error">
                      <div class="col-sm-12">
                        <small class="sml-red" v-if="!$v.pharmaFname.required">First Name is required.</small>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-4 my-0">
                    <input type="text" maxlength="25" :disabled="msdpUser.length>0" class="form-control form-control-sm" id="pharmaname" placeholder="Last Name"
                      v-model="pharmaLname">
                      <div class="row" v-show="$v.pharmaLname.$error">
                      <div class="col-sm-12">
                        <small class="sml-red" v-if="!$v.pharmaLname.required">Last Name is required.</small>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="checkbox-wrapper-65">
                <label for="cbk1-65">
                <input type="checkbox" id="cbk1-65" v-model="Dischecked">
                <span class="cbx mt-1">
                <svg width="12px" height="11px" viewBox="0 0 12 11">
                <polyline points="1 6.29411765 4.5 10 11 1"></polyline>
                </svg>
                </span>
                <span class="ml-4">{{ DisText }}</span>
                </label>
                </div>
              </span>
            <!-- <div class="checkbox-wrapper-27">
            <label class="checkbox">
            <input type="checkbox">
            <span class="checkbox__icon"></span>
            By checking this box, I declare that I have verified the diagnosis with the prescriber, and I have ensured the patient meets the criteria as submitted in this request. I also understand that the DPEBB may verify the information provided at any time. False information may result in the loss of access to the EDS portal or the removal of EDS coverage.
            </label>
            </div> -->

          <!-- <input type="checkbox" class="ml-1 mt-4" v-model="Dischecked" />
          <span class="ml-2">By checking this box, I declare that I have verified the diagnosis with the prescriber, and I have ensured the patient meets the criteria as submitted in this request.  I also understand that the DPEBB may verify the information provided at any time. False information may result in the loss of access to the EDS portal or the removal of EDS coverage. 

          </span> -->
   <hr>
              <div class="row pt-3">
                
                <div class="col-6">

                  <!-- <button v-on:click="SaveClaim"  type="button" class="btn btn-primary" :disabled="BtnSubmitdisabled"><i class="far fa-save"></i> Submit Claim </button> -->
                  <button v-on:click="SubmitEdsRequest" type="button" class="btn btn-primary"
                    :disabled="!Dischecked || CriteriaSelected == null"> <i class="far fa-save"></i> Submit </button>
                </div>
                <div class="col-6 ">
                  <button v-on:click="ExitEds" type="button" class="btn btn-primary m-1"> Cancel </button>
           
                </div>
              </div>
            </div>
            <div class="card-footer"></div>
          </div>
        </div>
        <div class="col-sm-1"></div>
      </div>


      <!-- <div class="card-header d-flex align-items-center  pl-1" style="height: 2rem; text-align:left;margin:2px;border-color: beige;">
          <h4 class="mt-2"><small class="text-muted primary primary-alert"><b> <i class="fa fa-server" aria-hidden="true"></i>Disclaimer: Please confirm and verify the criteria. </b></small></h4>
    </div>
 
    <div class="card-footer d-flex align-items-center  pl-1 mt-1" style="height: 3rem; text-align:left;">
           <input type="checkbox" class="ml-1"> <span class="ml-2">By clicking on this box, i verified the diagnosis with hospital card. </span>
    </div> -->
    </form>

  </div>
</template>
<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import Datepicker from "vuejs-datepicker";
import LayoutDefault from "@/Common/Default/DefaultLayout.vue";
import Subtitle from "@/Common/Default/SubTitle.vue";
import Card from "@/Common/Card.vue";
import CardBody from "@/Common/CardBody.vue";
import TileNote from "@/Common/TileNote.vue";
import { PopUpVariant } from "@/Common/Default/PopUpVariant";
import { request } from "http";
import PatientHistoryDetail from "@/components/Common/PatientHistoryDetail.vue";
import Vuelidate from "vuelidate";
import {
  helpers,
  required,
  minLength,
  sameAs,
  not,
  maxLength,
  numeric,
  integer,
  between,
requiredIf,
} from "vuelidate/lib/validators";

Vue.use(Vuelidate);
export default {
  props: {
    Type: "1",
  },
  name: "PatientHistorySearch",
  data: function () {
    return {
      userRole: '',
      HSN: "",
      DisText : "By checking this box, I declare that I have verified the diagnosis with the prescriber, and I have ensured the patient meets the criteria as submitted in this request. I also understand that the DPEBB may verify the information provided at any time. False information may result in the loss of access to the EDS portal or the removal of EDS coverage.",
      DisAuthuser : "Pharmacist License Number(D***)",
      DisName : "Pharmacist Name",
      userfName : '',
      userLname: '',
      msdpUser: '',
      pharmaLicense: '',
      pharmaFname: '',
      pharmaLname: '',
      authuser: '',
      Dischecked: '',
      EditableUnit: '',
      EditableLength: '',
      showdates: false,
      extEffectDate: "",
      extExpDate: "",
      //  newdate : (new Date()),
      // disablePastDates :(newdate) => { const today = new Date(); return date < today;},
      initialFromDate: "",
      BackdateFromDate: "",
      openEffectDate: new Date(),
      openExpDate: new Date(),
      //disableEffecDate: { from: new Date(Date.now()  - 8640000) }, // this will exclude today's day
      disableEffecDate: { from: new Date(Date.now()) }, //  include todays day
      disableExpDate: { to: new Date(Date.now()) },
      disableEffCal: true,
      disableExpCal: true,
      selectedEds: "",
      edsdosage: "",
      Eds: [],
      PrescName: "",
      Comments: "",
      Criteria: [],
      CriteriaSelected: null,
      DisbleProvider: false,
      MsgPopup: "",
      showError: false,
      TypeHeadinptClass: "form-control form-control-xs",
      boxTwo: "",
      BtnSubmitdisabled: 0,
      primaryText: "",
      PaidByThirdPArty: false,
      browseText: "Click Here",
      AppServiceID: 0,
      MaxMatch: 20,
      AppName: "",
      title: "EDS Request",
      subtitle: "Welcome",   
      fromDate: "",
      toDate: "",
      serviceDate: "",
      DateFormat: "",
      datapickClass: "form-control form-control-lg my-0",
      showInfo: false,
      providers: [],
      providerName: "",
      selectedProvider: null,
      detailProvider: null,
      clinics: [],
      selfClinic: [],
      clinicName: "",
      selectedEds: null,
      detailClinic: null,
      patientHistList: [],
      patient: null,
      PopUpVar: PopUpVariant,
      showDetailModal: false,
      showMessageModal: false,
      searched: false,
      phListingParams: [],
      phDetailParams: [],
      phDetails: [],
      phType: "CL",
      claimRequestNumber: "",
      Msg: "",
      Services: "",
      isAssessor: false,
      clinicno: "",
      columns: [
        "view",
        "claimtypedescription",
        "servicedate",
        "priorapprvno",
        "providerno",
        "name",
        "clinicno",
        "clinicname",
      ],

      options: {
        texts: {
          count:
            "Showing {from} to {to} of {count} records|{count} records|One record",
          first: "First",
          last: "Last",
          limit: "Records:",
          page: "Page:",
          noResults: "No Claim or Prior Approval Found",
          filterBy: "Filter by {column}",
          loading: "Loading...",
          defaultOption: "Select {column}",
          columns: "Columns",
        },

        responseAdapter({ data }) {
          return {
            data: formatData,
            count: data.length,
          };
        },

        perPage: 5,
        perPageValues: [5],

        dateColumns: ["servicedate"],

        filterable: true,

        listColumns: {
          claimtype: [
            { id: "CL", text: "Claim" },
            { id: "PA", text: "Prior Approval" },
          ],
        },

        templates: {
          servicedate(h, row) {
            return moment(row.servicedate, "YYYY-MM-DD").format("YYYY/MM/DD");
          },
        },

        headings: {
          claimtypedescription: "Claim/Prior Approval",
          status: "Status",
          priorapprvno: "Prior Approval #",
          providerno: "Provider #",
          servicedate: "Service Date",
          clinicno: "Clinic #",
          claimtype: "Claim Type",
          servicetype: "Service Type",
          name: "Provider Name",
          clinicname: "Clinic Name",
        },

        pagination: {
          edge: true,
          nav: "scroll",
          chunk: 5,
        },

        sortable: [
          "servicedate",
          "priorapprvno",
          "providerno",
          "clinicno",
          "claimtype",
          "servicetype",
        ],

        sortIcon: {
          base: "fas",
          is: "fa-sort",
          up: "fa-sort-up",
          down: "fa-sort-down",
        },
      },
    };
  },

  components: {
    Card,
    CardBody,
    TileNote,
    Datepicker,
    PatientHistoryDetail,
    Subtitle,
  },

  validations() {
    return {
      HSN: {
        required,
        minLength: minLength(9),
        numeric,
      },
      toDate: {
        needValue: (value) => this.ValidatetoDate(),
      },
      fromDate: {
        needValue: (value) => this.ValidatefromDate(),
      },
      Comments:{
        //needValue: value=> !(this.CriteriaSelected !== ""  && this.CriteriaSelected !== null && this.CriteriaSelected.commentallow == 'R')
      
        required: requiredIf(function () {
                return (this.CriteriaSelected !== ""  && this.CriteriaSelected !== null && this.CriteriaSelected.commentallow == 'R')
            }),
    
      },

      pharmaLicense:{
            required: requiredIf(function () {
                return (this.CriteriaSelected !== ""  && this.CriteriaSelected !== null)
            }),
    
      },

      pharmaFname:{
        
        required: requiredIf(function () {
          return (this.CriteriaSelected !== ""  && this.CriteriaSelected !== null)
            }),
    
      },

      pharmaLname:{
      
        required: requiredIf(function () {
          return (this.CriteriaSelected !== ""  && this.CriteriaSelected !== null)
            }),
    
      },


      //pharmaLname pharmaFname pharmaLicense
      // CriteriaSelected : 
      // {
      //   required: requiredIf(function () {
      //           return (this.selectedEds.length>0 && this.selectedEds != null)
      //       }),
      //    valueneeded : requiredIf (function(){
      //     return this.CriteriaSelected == null;
         
      //    })
      // },
      
      selectedProvider:{
        required
          //needValue: value=> (this.selectedProvider== "" ) || (this.selectedProvider !== null)
        },
         selectedEds:{
          required
           //needValue: value=> (this.selectedEds== "" ) || (this.selectedEds !== null)
         },

    };
  },

  filters: {
    moment: function (date) {
      return moment(date, "YYYY-MM-DD").format("YYYY/MM/DD");
    },
    stringify(value) {
      return JSON.stringify(value, null, 2);
    },
  },
  watch: {
    HSN: function () {
      //console.log('hsn length ' + this.HSN.length)
      if (this.HSN.length == 0) {
        this.resetAllControls();
      }
    },
    fromDate: function () {
         if (this.fromDate != null && this.fromDate !== "") {
          console.log(' at change ' + this.fromDate)
          if(this.CriteriaSelected.isother === false)
          {
             if(this.CriteriaSelected.openexpdate === false)
             {
              this.CalculateMaxDuration(this.fromDate);
             }

            //  if(this.CriteriaSelected.openexpdate === false)
            //  {
            //   this.CalculateMaxDuration(this.fromDate);
            //  }
             
          }
          
         }
    },
    
    selectedEds: function () {
      this.ResetDatesforEds();
      this.resetCriteriaControls(); 
    },

    CriteriaSelected: function () {
      //isother
      //this.ResetDatesforEds();

      var vm = this;
      if (this.CriteriaSelected !== null && this.CriteriaSelected !== "" && this.CriteriaSelected.isother === false ) {

        console.log(' at selected = ' + this.CriteriaSelected.isother)

        //old code 
        console.log(' before  at msdp' + vm.msdpUser.length)
        //(check > from && check < to)

        if(vm.msdpUser.length>0)
        {
             ////console.log(' at msdp')
              vm.pharmaFname = vm.userfName;
              vm.pharmaLname = vm.userLname;
              vm.pharmaLicense =  vm.msdpUser;
              vm.DisAuthuser = "Authorized User";
              vm.DisName = "Authorized User Name";
        }

      if  ( this.patient.age >= this.CriteriaSelected.minage && 
            this.patient.age <= this.CriteriaSelected.maxage  ) 
      {
        if(this.selectedEds !== null  && this.selectedEds !== undefined && this.selectedEds !== '')
          {
            console.log('this.selectedEds.backdating == '  + this.selectedEds.backdating);
            if(this.selectedEds.backdating == true)
            {
                this.disableEffCal = false;
            }
            else
            {
              console.log(' at disable effect to true')
              this.disableEffCal = true;
            }
          } 


        //this.showMsg(" first check", "", "no age issue found");
        this.showdates = true;
        ////console.log(' trace')
        var today =  moment().format('YYYY-MM-DD hh:mm:ss'); 
        var EdsEffectDate  =  moment(this.selectedEds.effectivedate).format('YYYY-MM-DD');
        var EdsExpirytDate  =  moment(this.selectedEds.expirydate).format('YYYY-MM-DD');
        
      //  console.log('at  this.selectedEds.expiry date  = ' + EdsExpirytDate)
        //console.log('at  toDate date  = ' + this.toDate)
        this.fromDate = today;
        //this.fromDate = new Date();//this.initialFromDate;
         console.log('at  this.selectedEds.effectivedate = ' + EdsEffectDate)
        //console.log('this.fromDate ' + this.fromDate) 
        var uselength; 
        uselength = this.CriteriaSelected.maxedslength;
//       console.log(' use length = ' + uselength)
  //     console.log(' this.CriteriaSelected.maxedunit =  ' + this.CriteriaSelected.maxedunit)
    //   console.log('open Exp date = ' + this.CriteriaSelected.openexpdate)
        if(this.CriteriaSelected.openexpdate === false) 
        {
            this.CalculateMaxDuration(today);
        }
        else if (this.CriteriaSelected.openexpdate === true)//&& this.CriteriaSelected.maxedslength === 999) 
        {
          //  console.log(' set todate BEfore Open Ended = ' +  this.toDate)
            this.toDate = moment('9999/12/30').add(1,'days').format("YYYY-MM-DD hh:mm:ss")

            //console.log(' set todate to open ended AFTER = ' +  this.toDate)
        }
        // check this logic.. the startofeffectdate should be greater then effective date of the standard. 

        //moment('2010-10-20').isSameOrBefore('2011-01-01', 'year');

        var startEffectDate;
        if (vm.selectedEds.backdating == true) {
          if (vm.selectedEds.bkunit == "D") { 
            startEffectDate =  moment(today).subtract(vm.selectedEds.bklength+1,'days').format("YYYY-MM-DD hh:mm:ss")
          }
          if (vm.selectedEds.bkunit == "M") { 
            startEffectDate =  moment(today).subtract(vm.selectedEds.bklength,'months').format("YYYY-MM-DD hh:mm:ss")
          }
          if (vm.selectedEds.bkunit == "Y") { 
            startEffectDate =  moment(today).subtract(vm.selectedEds.bklength,'years').format("YYYY-MM-DD hh:mm:ss")
          }
          var startDate = moment(startEffectDate).format("YYYY-MM-DD");

          console.log(' at back dating  startDate =  ' + startDate);
         // console.log(' at back dating  EdsEffectDate  ' + EdsEffectDate);
          if(moment(EdsEffectDate).isAfter(startDate, 'days'))
          {
            // console.log(' yes')
            // var newdate = moment(EdsEffectDate).format("YYYY-MM-DD")
            // console.log(newdate)
            startEffectDate = moment(EdsEffectDate).format("YYYY-MM-DD")
          }
          // old Code
          console.log(' at back dating  startEffectDate  ' + startEffectDate);
         

        // new code include msdp user future date HDP4293
          if(this.msdpUser.length>0)
          {
              // set the calander for future date.  from todays date to 90 days

              var futureEndDate =  moment(today).add(
                      90,
                      "days"
                    );
           //   console.log(" MSDP new Future date = " + moment(futureEndDate).format("YYYY-MM-DD"))
             // console.log(" MSDP new start date = " + moment(startEffectDate).format("YYYY-MM-DD"))
              
              //console.log(" MSDP new toDate date = " + moment(this.toDate).format("YYYY-MM-DD"))
              //console.log(" MSDP new Eds Expiry Date date = " + moment(this.EdsExpirytDate).format("YYYY-MM-DD"))
            if(moment(futureEndDate).isAfter(this.toDate, 'days'))
            {
              //console.log(' future date is after  yes')
              // var newdate = moment(EdsEffectDate).format("YYYY-MM-DD")
              //console.log('future date is greater than  expiry date so switch EdsExpirytDate ' + this.toDate)
              futureEndDate = moment(this.toDate).format("YYYY-MM-DD")
            }
            this.disableEffecDate = {  to: new Date(startEffectDate) , from: new Date(futureEndDate)  };
            console.log(" MSDP new Future date = " + moment(futureEndDate).format("YYYY-MM-DD"))
            //this.disableEffecDate = { from: new Date(futureEndDate) , to: new Date(Date.now()) };


          }
          else{
            this.disableEffecDate = { to: new Date(startEffectDate) , from: new Date(Date.now()) };
          }
          // else{
          //   this.disableEffecDate = { to: new Date(startEffectDate) , from: new Date(Date.now()) };
          // }

        }

        //console.log('this.msdpUser.length ' + this.msdpUser.length)
        else if (vm.selectedEds.backdating == false && this.msdpUser.length>0)
        {
            // set the calander for future date.  from todays date to 90 days

            var futureEndDate =  moment(today).add(
                    90,
                    "days"
                  );

            if(moment(futureEndDate).isAfter(EdsExpirytDate, 'days'))
            {
              // console.log(' yes')
              // var newdate = moment(EdsEffectDate).format("YYYY-MM-DD")
              console.log('EdsExpirytDate = ' + EdsExpirytDate)
              console.log('here in back dating false: toDate = ' + this.toDate) 

              futureEndDate = moment(EdsExpirytDate).format("YYYY-MM-DD")
            }
            console.log(" MSDP new Future date = " + moment(futureEndDate).format("YYYY-MM-DD"))

            // old code
            this.disableEffecDate = { from: new Date(futureEndDate) , to: new Date(Date.now()) };
            // new code 
            //this.disableEffecDate = { from: new Date(futureEndDate) , to: new Date(startEffectDate) };
            //this.disableEffecDate = {from: new Date(futureEndDate) };
            this.disableEffCal = false;
        }


        //console.log(' this.CriteriaSelected.allowexpedit = ' + this.CriteriaSelected.allowexpedit)
        if (this.CriteriaSelected.allowexpedit == true) {
          this.disableExpDate = { from: new Date( vm.toDate) , to: new Date(Date.now()) };
          this.disableExpCal = false;
        }
        else {
          this.disableExpDate = { from: new Date( vm.toDate) , to: new Date(Date.now()) };
          this.disableExpCal = true;
          //console.log(' at 2')  
        } 
      }
  
      if(this.patient.age < this.CriteriaSelected.minage || this.patient.age > this.CriteriaSelected.maxage)
      {
            this.showMsg('Patient Age is not Eligible for the selected Criteria','','EDS Criteria Error');
          
            this.showdates = false;
            this.resetCriteriaControls();
         
            this.GetCriteria();
      } 
      }
      if (this.CriteriaSelected !== null && this.CriteriaSelected !== "" && this.CriteriaSelected.isother === true )
      {
        console.log(' at other' + this.CriteriaSelected.isother)
        this.showdates = true;
        var today =  moment().format('YYYY-MM-DD hh:mm:ss'); 
        this.fromDate = today;
        this.toDate = today;
        this.disableExpCal = true;
        this.disableEffCal = true;
      }
    },
  },
  methods: {
    CalculateMaxDuration(CriteriaEffecDate){
     console.log(' at calculate max duration max length = ' + this.CriteriaSelected.maxedslength)
     console.log(' max days/month/years  = ' + this.CriteriaSelected.maxedunit)      
     var uselength = this.CriteriaSelected.maxedslength;
      if (this.CriteriaSelected.maxedunit == 'D') { 
          var r =  moment(CriteriaEffecDate).add(
            uselength-1,
            "days"
          );
          console.log('at after days add ' + r.format("YYYY-MM-DD"))
          this.toDate = r.format("YYYY-MM-DD hh:mm:ss"); //var eff  = moment([vm.selectedEds.effectivedate]).format('YYYY-MM-DD') 
        }
        if (this.CriteriaSelected.maxedunit == 'M') { 
          var r =  moment(CriteriaEffecDate).add(
            uselength,
            "months"
          );
          this.toDate = r.format("YYYY-MM-DD hh:mm:ss"); //var eff  = moment([vm.selectedEds.effectivedate]).format('YYYY-MM-DD') 
        }
        if (this.CriteriaSelected.maxedunit == 'Y') { 
          var r =  moment(CriteriaEffecDate).add(
            uselength,
            "years"
          );
          this.toDate = r.format("YYYY-MM-DD hh:mm:ss"); //var eff  = moment([vm.selectedEds.effectivedate]).format('YYYY-MM-DD') 
        }

          console.log(' at duration todate = ' + this.toDate)  
        if (this.CriteriaSelected.allowexpedit == true) {
          this.disableExpDate = { from: new Date( this.toDate) , to: new Date(CriteriaEffecDate) };
          this.disableExpCal = false;
        }
        else {
          this.disableExpDate = { from: new Date( this.toDate) , to: new Date(CriteriaEffecDate) };
          this.disableExpCal = true;
          //console.log(' at 2')  
        } 

    },
    showMsgBox(msg, data, Title, MethodNo) {
      var vm = this;
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm(msg, {
          title: Title,
          size: "md",
          buttonSize: "md",
          okVariant: "danger",
          okTitle: "Close",
          footerClass: "p-2",
          hideHeaderClose: true,
          hideHeaderCancel: true,
          centered: true,

        })
        .then((value) => {
          this.boxTwo = value;
          //////console.log(value)
          if (value) {
            if (MethodNo == 2) {
              //vm.popupText = "";
              ExitEds();
              //vm.DelConfirm = this.boxTwo;

            }
            if (MethodNo == 1)
            {

            }
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },

    ExitEds(){
          this.$router.push('/EDS/Home')
      },
    getUserInfo(){
     
      ////console.log(" id  = " + this.selectedEds.id);
      var vm = this;
      vm.searched = false;
      var params = new URLSearchParams();
      //params.append("usergroupid", this.selectedEds.id);
      axios
        .get("SaskHealthApi/Codes/UserInfo", {
          headers: { Authorization: "Bearer " + localStorage.access_token },
          params,
        })
        .then(function (response) {
         // console.log('USer info response ' + response.data);
         // console.log(response.data.fullname.length);
          if (response.data.fullname.length > 0 )
          {

             var names  = response.data.fullname.split('|')
            // //console.log(names)
              vm.userfName = names[0]
              vm.userLname = names[1]
              vm.msdpUser = response.data.userid; 
          } 

        })
        .catch(function (er) {
          //console.log(er);
        })
        .then(function () {
       
        });
       
    
    },

    getDisclaimerInfo(){
     
     ////console.log(" id  = " + this.selectedEds.id);
     var vm = this;
     vm.searched = false;
     var params = new URLSearchParams();
     //params.append("usergroupid", this.selectedEds.id);
     axios
       .get("SaskHealthApi/Codes/GetDisclaimer", {
         headers: { Authorization: "Bearer " + localStorage.access_token },
         params,
       })
       .then(function (response) {
         ////console.log(response.data.fullname.length);
         if (response.data.length > 0 )
         {
             
            vm.DisText = response.data
         } 

       })
       .catch(function (er) {
         //console.log(er);
       })
       .then(function () {
      
       });
      
   
   },

    SubmitEdsRequest() {
      var vm = this;
      vm.$v.$touch();
      if (!vm.$v.$invalid) {
      //console.log(' interchangeName ' + vm.CriteriaSelected)
      vm.disableSave = false;
      var url = "SaskHealthApi/Host/PostEDSRequest/";
      var params = new URLSearchParams();
      var bodyFormData = new FormData();
      bodyFormData = {
        "HSN": vm.HSN,
        "DIN": vm.selectedEds.din,
        "EffectiveDate": moment(vm.fromDate).format("YYYY-MM-DD"),
        "ExpiryDate": moment(vm.toDate).format("YYYY-MM-DD"),
        "Prescriber": vm.selectedProvider.providerno,
        "Orgid" : vm.selectedProvider.orgid,
        "GenericName": vm.selectedEds.eds,
        "BrandName": vm.selectedEds.eds, 
        "UserType": vm.selectedEds.usertype,
        "Dosage": vm.selectedEds.dosage,
        "IsBySingleDin": vm.selectedEds.singledin,
        "GenLetter": vm.CriteriaSelected.generateletter,
        "Diagnosis": vm.CriteriaSelected.diagnosis,
        "Comment": vm.Comments,
        "PharmacistLicense": vm.pharmaLicense,
        "PharmacistFName": vm.pharmaFname,
        "PharmacistLName": vm.pharmaLname


      };
      axios({
        method: "post",
        url: url,
        headers: {
          Authorization: "Bearer " + vm.$store.getters.GetAccessToken,
        },
        data: bodyFormData,
      })
        .then(function (response) {
            vm.showMsgAndRedirect(response.data,'', 'EDS Request Message' ,true)
        })
        .catch(function (er) {
          if (er.response) 
          {
            ////console.log('Server responded with status code:', er.response.status);
            ////console.log('Response data:', er.response.data.message);
            
            if (er.response.status == 400) {
              if (er.response.data.message.length) {
                //vm.showMsg(er.response.data.message, "", "EDS record error");
                vm.showMsg(er.response.data.message,'', 'EDS Request Message')
              }
            }

            if (er.response.status == 500) {
              vm.showMsg("Network Related Error ! Please contact system administrator", "", "EDS Record Error");
              // if (er.response.data.message.length) {
              //   vm.showMsg("Network Related Error ! Please contact system administrator", "", "EDS record error");

              // }
            }
           // else
            // ////console.log('here')
            // vm.showMsg("Network Related Error ! Please contact system administrator.", "", "EDS Record Error");



          }
     
        })
        .then(function () {
          vm.loading = false;
        });
    
      }
      },
    resetAllControls() {
      //console.log('he')
      //this.HSN =''
      this.selectedEds = null
      this.CriteriaSelected = null
      this.selectedProvider = null
      this.EditableLength = ''
      this.EditableUnit = ''
      this.edsdosage = ''
      this.providerName = ''
      this.toDate = ''
      this.fromDate = ''
    },

    resetCriteriaControls() {
      //console.log('he')
      this.Criteria=[];
      this.CriteriaSelected = null
      this.EditableLength = ''
      this.EditableUnit = ''
      this.toDate = ''
      this.fromDate = ''
      this.pharmaFname = ""
      this.pharmaLicense = ""
      this.pharmaLname = ""
      this.showdates= false;

    },
    ResetDatesforEds() {
      var vm = this;
      // if (this.selectedEds != null && this.selectedEds !== "") {
      //   //console.log('at select Eds')
      //   vm.initialFromDate = moment(vm.selectedEds.effectivedate).format('YYYY-MM-DD');
      //   this.extEffectDate = vm.initialFromDate;
      //   vm.disableEffect = true;
      //   //console.log(' open ' + moment(vm.selectedEds.expirydate).format('YYYY-MM-DD'))
      //   // if(moment(vm.selectedEds.expirydate).format('YYYY-MM-DD') !== '9999-12-31')
      //   // vm.toDate = vm.selectedEds.expirydate;
      //   // else
      //   // {
      //   //   vm.toDate =  new Date();
      //   // }
      //   vm.toDate = vm.selectedEds.expirydate;
      //   vm.disableExpDate = { to: new Date(vm.initialFromDate), from: new Date(vm.toDate) };
      //   vm.disableEffecDate = { to: new Date(vm.initialFromDate), from: new Date(vm.toDate) };
      //   if (vm.selectedEds.backdating == true) {
      //     //bkunit bklength
      //     if (vm.selectedEds.bkunit == "M") {
      //       var disEffectDate = vm.SubMonths(
      //         moment(vm.selectedEds.effectivedate).format(
      //           "YYYY-MM-DD hh:mm:ss"
      //         ),
      //         vm.selectedEds.bklength
      //       );
      //       this.extEffectDate = disEffectDate;
      //       //vm.disableExpDate = { to: new Date(), from: new Date(vm.toDate) };
      //       vm.disableEffecDate = { to: new Date(disEffectDate), from: new Date(vm.toDate), };
      //       vm.disableExpDate = { to: new Date(disEffectDate), from: new Date(vm.toDate) };
      //       vm.fromDate = new Date();
      //       // //console.log(' from date after subtract = '+ vm.fromDate)
      //       // //vm.extEffectDate = vm.fromDate;
      //       // //console.log(" ext effect date " + vm.extEffectDate);
      //       // //console.log(" new effe  date " + new Date().getDate());
      //       //vm.fromDate = vm.initialFromDate;
      //       //vm.openEffectDate =new Date();//.format('YYYY-MM-DD'); //vm.initialFromDate.Date;//vm.fromDate.Date;
      //       // vm.openExpDate = new Date();
      //       // vm.toDate =  vm.AddDays(new Date(),1);

      //       // //console.log(" openEffectDate  " + vm.openEffectDate);
      //       // //console.log(
      //       //   "after disableEffecDate  = " + vm.disableEffecDate.to
      //       // );

      //       //vm.disableEffecDate = { to: new Date(vm.fromDate - 8640000) }
      //       // not use full atthis point vm.fromDate = moment([vm.selectedEds.effectivedate]).add(moment.duration({M: vm.selectedEds.bklength})).format('YYYY-MM-DD')

      //       //vm.fromDate = moment([vm.selectedEds.effectivedate]).add(moment.duration({d: vm.selectedEds.bklength})).format('YYYY-MM-DD')

      //       //vm.fromDate = moment(vm.selectedEds.effectivedate).subtract(vm.selectedEds.bklength,'months').format('YYYY-MM-DD')
      //     }
      //     if (vm.selectedEds.bkunit == "D") {
      //       // //console.log(vm.selectedEds.bklength)
      //       // //console.log(moment(vm.selectedEds.effectivedate).subtract(2,'days'))
      //       // var v =moment(vm.selectedEds.effectivedate).subtract(vm.selectedEds.bklength,'days')
      //       // //console.log(v)
      //       // //console.log(v.format('YYYY-MM-DD'))

      //       //vm.fromDate = vm.AddMonths(moment(vm.selectedEds.effectivedate).format('YYYY-DD-MM'), vm.selectedEds.bklength)
      //       var r = moment(vm.selectedEds.effectivedate).subtract(
      //         vm.selectedEds.bklength,
      //         "days"
      //       );

      //       vm.fromDate = r.format("YYYY-MM-DD hh:mm:ss"); //var eff  = moment([vm.selectedEds.effectivedate]).format('YYYY-MM-DD')

      //       vm.disableEffecDate = {
      //         to: new Date(vm.fromDate),
      //         from: new Date(vm.toDate),
      //       };
      //       vm.disableExpDate = { to: new Date(), from: new Date(vm.toDate) };

      //       vm.extEffectDate = vm.fromDate;
      //       //console.log(" ext effect date " + vm.extEffectDate);

      //       //console.log(
      //         "after disableEffecDate  = " + vm.disableEffecDate.to
      //       );

      //       //vm.fromDate = vm.initialFromDate;

      //       vm.fromDate = new Date();

      //       //vm.openEffectDate = vm.fromDate.Date;
      //       //vm.disableEffecDate = { to: new Date(vm.fromDate - 8640000) }
      //       ///  not usefull at this point vm.fromDate = moment([eff]).add(moment.duration({d: vm.selectedEds.bklength})).format('YYYY-MM-DD')

      //       //vm.fromDate = vm.SubDays(vm.selectedEds.effectivedate,vm.selectedEds.bklength)
      //     }
      //   }

      // }
      // else
      // {
      //     this.resetCriteriaControls();
      // }

    },

    radiochange(value) {
      //console.log("radio value " + value);
    },
    Go() {
      this.$router.push("/DPEBB/MainHome");
    },
    ClosePopup() {
      this.showError = false;
    },
    Show() {
      this.showInfo = true;
    },

    GetHsnInfo() {
      var vm = this;
      this.resetCriteriaControls();
      //vm.GetCriteria();
      //console.log(' v touch valid ' + vm.$v.$touch)
      vm.$v.$touch();
      if (!vm.$v.$invalid) {
        var params = new URLSearchParams();
        params.append("HSN", this.HSN);
        axios
          .get("SaskHealthApi/Host/GetHsnInq", {
            headers: { Authorization: "Bearer " + localStorage.access_token },
            params,
          })
          .then(function (response) {
            vm.patient = response.data;
            vm.searched = true;
            vm.GetCriteria();
          })
          .catch(function (er) {
            //console.log(er);
            if (er.response) {
              if (er.response.status == 400) {
                if (er.response.data.message.length) {
                  vm.showMsg(er.response.data.message, "", "HSN Search Error");
                }
              } else
                vm.showMsg(
                  "Network Related Error ! Please contact system administrator.",
                  "",
                  "HSN Search Error"
                );
            } else vm.showMsg("Network Related Error ! Please contact system administrator.", "", "HSN Search Error");
          });
      }
    },
    GetCriteria() {
      //console.log(" id  = " + this.selectedEds.id);
      var vm = this;
      vm.searched = false;
      var params = new URLSearchParams();
      params.append("usergroupid", this.selectedEds.id);
      axios
        .get("SaskHealthApi/Codes/GetEDSCriteria", {
          headers: { Authorization: "Bearer " + localStorage.access_token },
          params,
        })
        .then(function (response) {
          vm.Criteria = response.data;
        })
        .catch(function (er) {
          //console.log(er);
        })
        .then(function () {

        });
    },
    AddMonths(effecdate, months) {
      //console.log(effecdate);
      var fm = moment(effecdate).format("YYYY-MM-DD");
      fm = moment(fm).add(months, "M");
      ////console.log(fm)
      var fmEnd = moment(fm).endOf("month");
      return effecdate != fm && fm.isSame(fmEnd.format("YYYY-MM-DD"))
        ? fm.add(months, "d").format("YYYY-MM-DD")
        : fm.format("YYYY-MM-DD");
    },

    SubMonths(effecdate, months) {
      //console.log(effecdate);
      var fm = moment(effecdate).format("YYYY-MM-DD hh:mm:ss");
      fm = moment(fm).subtract(months, "M");
      ////console.log(fm)
      var fmEnd = moment(fm).endOf("month");
      return effecdate != fm && fm.isSame(fmEnd.format("YYYY-MM-DD hh:mm:ss"))
        ? fm.subtract(months, "d").format("YYYY-MM-DD hh:mm:ss")
        : fm.format("YYYY-MM-DD hh:mm:ss");
    },

    AddDays(adddate, days) {
      // //console.log(effecdate)
      // var fm = moment(effecdate).format('YYYY-MM-DD') ;
      // fm = moment(fm).subtract(months, 'M');
      // ////console.log(fm)
      // var fmEnd = moment(fm).endOf('month');
      // return  effecdate != fm && fm.isSame(fmEnd.format('YYYY-MM-DD')) ? fm.subtract(months, 'd').format('YYYY-MM-DD') : fm.format('YYYY-MM-DD');
      return moment(adddate)
        .add(days, "days")
        .format("YYYY-MM-DD hh:mm:ss");
    },
    SubDays(subdate, days) {
      // //console.log(effecdate)
      // var fm = moment(effecdate).format('YYYY-MM-DD') ;
      // fm = moment(fm).subtract(months, 'M');
      // ////console.log(fm)
      // var fmEnd = moment(fm).endOf('month');
      // return  effecdate != fm && fm.isSame(fmEnd.format('YYYY-MM-DD')) ? fm.subtract(months, 'd').format('YYYY-MM-DD') : fm.format('YYYY-MM-DD');
      return moment(subdate)
        .subtract(days, "days")
        .format("YYYY-MM-DD hh:mm:ss");
    },
    GetAllEds() {
      var vm = this;
      var local = []; //GetAllEDSAllocation
      var url = "SaskHealthApi/Codes/GetAllEDSAllocationsByRole";
      if (this.isAssessor) {
        url = "SaskHealthApi/Codes/GetAllEDSAllocationandCriteria";
      }
      var params = new URLSearchParams();
      // params.append('ServiceID', 1);
      axios
        .get(url, {
          headers: { Authorization: "Bearer " + localStorage.access_token },
          params,
        })
        .then(function (response) {
          vm.Eds = response.data;
        })
        .catch(function (er) {
          //console.log(er);
          // vm.TblData = [];
          if (er.response) {
            if (er.response.status == 400) {
              if (er.response.data.message.length) {
                vm.showMsg(
                  er.response.data.message,
                  "",
                  "User Type Search Error"
                );
              }
            } else
              vm.showMsg(
                "Network Related Error ! Please contact system administrator.",
                "",
                "HSN Search Error"
              );
          } else vm.showMsg("Network Related Error ! Please contact system administrator.", "", "HSN Search Error");
        });
    },
    showMsgAndRedirect(msg, data, Title,redirect) {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxOk(msg, {
          title: Title,
          size: "md",
          buttonSize: "md",
          okVariant: "danger",
          okTitle: "Close",
          footerClass: "p-2",
          hideHeaderClose: true,
          hideHeaderCancel: true,
          centered: true,
        })
        .then((value) => {
          this.boxTwo = this.msg;
          if (value) {
            this.$router.push('/EDS/Home')
            //console.log(' box value ' + value)
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },

    showMsg(msg, data, Title) {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxOk(msg, {
          title: Title,
          size: "md",
          buttonSize: "md",
          okVariant: "danger",
          okTitle: "Close",
          footerClass: "p-2",
          hideHeaderClose: true,
          hideHeaderCancel: true,
          centered: true,
        })
        .then((value) => {
          this.boxTwo = this.msg;
          if (value) {
            //console.log(' box value ' + value)
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    EdsChanged() {
      //console.log("eds " + this.edsdosage);
      //console.log("eds selected " + this.selectedEds);
      if (this.edsdosage === "" || this.edsdosage === null) {
        //console.log("at null");
        this.selectedEds = null;
        this.searched = false;
        this.CriteriaSelected = "";
      }
    },
    ProvidertextChanged() {
      if (this.providerName == "") {
        this.selectedProvider = null;
        this.searched = false;
      }
    },
    HSNtextChanged() {
      if (this.HSN == null || this.HSN.length < 9) {
        this.patient = null;
        this.searched = false;
      }
    },
    CheckProvider() {
      this.selectedProvider = this.providers.find(
        (x) => x.providerno == this.providerName
      );
    },
    GetProviders() {
      var vm = this;
      var params = new URLSearchParams();
      params.append("ServiceID", this.AppServiceID);
      axios
        .get("SaskHealthApi/Codes/GetAllProvidersByService", {
          headers: { Authorization: "Bearer " + localStorage.access_token },
          params,
        })
        .then(function (response) {
          vm.providers = response.data;
          vm.showInfo = true;
        })
        .catch(function (er) {
          //console.log(er);
        })
        .then(function () { 
          
        });
    },
    ValidateExtExpDate() {
      if (
        (this.toDate == "" || this.toDate == null) &&
        this.extExpDate != "" && this.extExpDate != null
      ) {
        if (
          moment(this.toDate).toISOString() <=
          moment(this.extExpDate).toISOString()
        ) {
          return true;
        } else return false;
      } else {
        return false;
      }
    },

    ValidateExtEfectDate() {
      if (
        (this.fromDate == "" || this.fromDate == null) &&
        this.extEffectDate != "" && this.extEffectDate != null
      ) {
        if (
          moment(this.fromDate).toISOString() <=
          moment(this.extEffectDate).toISOString()
        ) {
          return true;
        } else return false;
      } else {
        return false;
      }
    },

    ValidatetoDate() {
      //  //console.log('ValidatetoDate this.todate: '+ this.toDate);
      //   var isafter = moment(this.toDate).isAfter('1970/01/01', 'year');
      // //  //console.log('toDate isafter: ' + isafter);
      //   if (isafter == false)
      //   {
      // //    //console.log('toDate not greater than 1970!!!!');
      //     return false;
      //   }
      //   else
      //   {
      // //     //console.log('toDate greater than 1970');
      //   }
      if (
        (this.toDate == "" || this.toDate == null) &&
        this.fromDate != "" && this.fromDate != null
      ) {
        return false;
      } else if (
        (this.toDate != "" || this.toDate != null) &&
        this.fromDate != "" && this.fromDate != null
      ) {
        if (
          moment(this.fromDate).toISOString() <=
          moment(this.toDate).toISOString()
        ) {
          return true;
        } else return false;
      } else if (
        (this.toDate != "" || this.toDate != null) &&
        (this.fromDate == "" || this.fromDate == null)
      ) {
        return true;
      } else {
        return false;
      }
    },
    ValidatefromDate() {
      ////console.log('ValidatefromDate this.fromdate: '+ this.fromDate);
      //   var isafter = moment(this.fromDate).isAfter('1970/01/01', 'year');  // false
      //   ////console.log('fromdate isafter: ' + isafter);
      //   if (isafter == false)
      //   {
      //  //   //console.log('from Date not greater than 1970!!!! ');
      //     return false;
      //   }
      //   else
      //   {
      //   //   //console.log('fromDate greater than 1970');
      //   }
      if (
        (this.fromDate == "" || this.fromDate == null) &&
        this.toDate != "" && this.toDate != null
      ) {
        if (
          moment(this.fromDate).toISOString() <
          moment(this.toDate).toISOString()
        ) {
          return true;
        } else return false;
      } else {
        return true;
      }
    },

    // GetUserClinics(){
    //          var vm = this;
    //          var params = new URLSearchParams();
    //         params.append('ServiceID', this.AppServiceID);
    //           axios.get('/SaskHealthApi/Codes/GetUserClinic', { headers: { 'Authorization': 'Bearer ' + localStorage.access_token }, params})
    //               .then(function (response) {
    //                   vm.clinics = response.data;
    //                   if(!vm.isAssessor){
    //                     vm.selectedClinic= vm.clinics[0];
    //                     vm.clinicno = vm.clinics[0].clinicno.toString();
    //                     vm.columns = ['view',  "claimtypedescription" ,'servicedate', 'priorapprvno','providerno' , 'name'];
    //                   }
    //                   // //console.log(vm.selectedClinic);
    //               })
    //           .catch(function (er) {
    //               //console.log(er)
    //           })
    //       },
    ClinictextChanged() {
      if (this.clinicno == "") {
        this.selectedClinic = null;
        this.searched = false;
      }
    },
    ProvidertextChanged() {
      if (this.providerName == "") {
        this.selectedProvider = null;
        this.searched = false;
      }
    },
    GetIsAssessor() {
      var params = new URLSearchParams();
      var vm = this;

      axios
        .get("SaskHealthApi/Codes/IsAssessorOrSuper?_=" + Date.now(), {
          headers: { Authorization: "Bearer " + localStorage.access_token },
          params,
        })
        .then(function (response) {
          // //console.log(response.data);
          vm.isAssessor = response.data;
        })
        .catch(function (er) {
          //console.log(er);
        })
        .then(function () {
          vm.GetAllEds();
        });
    },
    ClearSearch() {
      var vm = this;
      vm.providerName = "";
      vm.selectedProvider = null;
      vm.clinicName = "";
      vm.selectedClinic = null;
      vm.patient = null;
      vm.toDate = null;
      vm.fromDate = "";
      vm.HSN = "";
      vm.searched = false;
      vm.phDetailParams = [];
      vm.phListingParams = [];
      vm.clinicno = vm.selfClinic[0].clinicno;
      vm.selectedClinic = vm.selfClinic[0];
      vm.clinicName = vm.selfClinic[0].clinicname;
      this.$refs.providerRef.inputValue = "";
      this.$refs.clinicRef.inputValue = "";
    },

    CloseDetailModal() {
      this.showDetailModal = false;
    },

    PopMsgClose() { },

    OnResize(event) { },
  },

  computed: {
    UserName() {
      return !this.$store.getters.GetCurrentUser
        ? false
        : this.$store.getters.GetCurrentUser;
    },
    AllAppLevel() {
      return this.$store.getters.GetAllApplevel;
    },
  },

  created: function () {
    this.$emit("update:layout", LayoutDefault);
    const auth = this.$store.getters.IsAuth;
    this.AppServiceID = this.$store.getters.GetDentalID;
    if (auth) {
      this.dateFormat = this.$store.getters.GetDateFormat;

      //console.log("home app service id  = " + this.AppServiceID);
      this.getUserInfo();
      this.getDisclaimerInfo();
    }
    //console.log("home app service id  = " + this.AppServiceID);

    this.DateFormat = this.$store.getters.GetDateFormat;
    //this.disableEffecDate = new Date(Date.now() - 8640000)
    //this.disableExpDate = new Date(Date.now() - 8640000)
    //this.toDate = { to: new Date(Date.now() - 8640000) }
    //this.fromDate = { to: new Date(Date.now() - 8640000) }
    this.GetProviders();
  },

  beforeCreate: function () {
    //console.log("at before");
    this.$store.dispatch("AddServiceID", this.$store.getters.GetDentalID);
    this.$store.dispatch("GetMenuItems", this.$store.getters.GetDentalID);
  },

  mounted: function () {
    this.GetIsAssessor();
  },
};
</script>

<style scopped>

.checkbox-wrapper-27 .checkbox {
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
  }
  .checkbox-wrapper-27 .checkbox > input[type="checkbox"] {
    position: absolute;
    opacity: 0;
    z-index: -1;
  }

  .checkbox-wrapper-27 .checkbox__icon {
    display: inline-block;
    color: #999;
    vertical-align: middle;
    margin-right: 5px;
  }
  .checkbox-wrapper-27 input[type="checkbox"]:checked ~ .checkbox__icon {
    color: #2A7DEA;
  }

  .checkbox-wrapper-27 .checkbox__icon:before {
    font-family: "icons-27";
    speak: none;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .checkbox-wrapper-27 .icon--check:before,
  .checkbox-wrapper-27 input[type="checkbox"]:checked ~ .checkbox__icon:before {
    content: "\e601";
  }

  .checkbox-wrapper-27 .icon--check-empty:before,
  .checkbox-wrapper-27 .checkbox__icon:before {
    content: "\e600";
  }

  @font-face {
    font-family: "icons-27";
    font-weight: normal;
    font-style: normal;
    src: url("data:application/x-font-woff;charset=utf-8;base64,d09GRk9UVE8AAAR4AAoAAAAABDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABDRkYgAAAA9AAAAPgAAAD4fZUAVE9TLzIAAAHsAAAAYAAAAGAIIvy3Y21hcAAAAkwAAABMAAAATBpVzFhnYXNwAAACmAAAAAgAAAAIAAAAEGhlYWQAAAKgAAAANgAAADYAeswzaGhlYQAAAtgAAAAkAAAAJAPiAedobXR4AAAC/AAAABgAAAAYBQAAAG1heHAAAAMUAAAABgAAAAYABlAAbmFtZQAAAxwAAAE5AAABOUQYtNZwb3N0AAAEWAAAACAAAAAgAAMAAAEABAQAAQEBCGljb21vb24AAQIAAQA6+BwC+BsD+BgEHgoAGVP/i4seCgAZU/+LiwwHi2v4lPh0BR0AAAB8Dx0AAACBER0AAAAJHQAAAO8SAAcBAQgPERMWGyBpY29tb29uaWNvbW9vbnUwdTF1MjB1RTYwMHVFNjAxAAACAYkABAAGAQEEBwoNL2X8lA78lA78lA77lA6L+HQVi/yU+JSLi/iU/JSLBd83Fffsi4v77Pvsi4v37AUOi/h0FYv8lPiUi4v33zc3i/s3++yLi/fs9zeL398F9wCFFftN+05JzUdI9xr7GveR95FHzwUO+JQU+JQViwwKAAMCAAGQAAUAAAFMAWYAAABHAUwBZgAAAPUAGQCEAAAAAAAAAAAAAAAAAAAAARAAAAAAAAAAAAAAAAAAAAAAQAAA5gEB4P/g/+AB4AAgAAAAAQAAAAAAAAAAAAAAIAAAAAAAAgAAAAMAAAAUAAMAAQAAABQABAA4AAAACgAIAAIAAgABACDmAf/9//8AAAAAACDmAP/9//8AAf/jGgQAAwABAAAAAAAAAAAAAAABAAH//wAPAAEAAAAAAACkYCfgXw889QALAgAAAAAAz65FuwAAAADPrkW7AAD/4AIAAeAAAAAIAAIAAAAAAAAAAQAAAeD/4AAAAgAAAAAAAgAAAQAAAAAAAAAAAAAAAAAAAAYAAAAAAAAAAAAAAAABAAAAAgAAAAIAAAAAAFAAAAYAAAAAAA4ArgABAAAAAAABAA4AAAABAAAAAAACAA4ARwABAAAAAAADAA4AJAABAAAAAAAEAA4AVQABAAAAAAAFABYADgABAAAAAAAGAAcAMgABAAAAAAAKACgAYwADAAEECQABAA4AAAADAAEECQACAA4ARwADAAEECQADAA4AJAADAAEECQAEAA4AVQADAAEECQAFABYADgADAAEECQAGAA4AOQADAAEECQAKACgAYwBpAGMAbwBtAG8AbwBuAFYAZQByAHMAaQBvAG4AIAAxAC4AMABpAGMAbwBtAG8AbwBuaWNvbW9vbgBpAGMAbwBtAG8AbwBuAFIAZQBnAHUAbABhAHIAaQBjAG8AbQBvAG8AbgBHAGUAbgBlAHIAYQB0AGUAZAAgAGIAeQAgAEkAYwBvAE0AbwBvAG4AAAAAAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA==") format("woff");
  }



.checkbox-wrapper-65 *,
  .checkbox-wrapper-65 ::after,
  .checkbox-wrapper-65 ::before {
    box-sizing: border-box;
  }
  .checkbox-wrapper-65 .cbx {
    /* position: relative; */
    position: absolute;
    display: inline-flex;
    float: left;
    width: 18px;
    height: 18px;
    border-radius: 4px;
    background-color: #606062;
    background-image: linear-gradient(#474749, #606062);
    box-shadow: inset 0 1px 1px rgba(255,255,255,0.15), inset 0 -1px 1px rgba(0,0,0,0.15);
    transition: all 0.15s ease;
  }
  .checkbox-wrapper-65 .cbx svg {
    position: absolute;
    top: 3px;
    left: 3px;
    fill: none;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke: #fff;
    stroke-width: 2;
    stroke-dasharray: 17;
    stroke-dashoffset: 17;
    transform: translate3d(0, 0, 0);
  }
  .checkbox-wrapper-65 .cbx + span {
    float: left;
    margin-left: 6px;
  }
  .checkbox-wrapper-65 {
    user-select: none;
  }
  .checkbox-wrapper-65 label {
    display: inline-block;
    cursor: pointer;
  }
  .checkbox-wrapper-65 input[type="checkbox"] {
    position: absolute;
    display: none;
    visibility: hidden;
  }
  .checkbox-wrapper-65 input[type="checkbox"]:checked + .cbx {
    background-color: #606062;
    background-image: linear-gradient(#255cd2, #1d52c1);
  }
  .checkbox-wrapper-65 input[type="checkbox"]:checked + .cbx svg {
    stroke-dashoffset: 0;
    transition: all 0.15s ease;
  }



.pre-formatted {
  white-space:pre-wrap;
}
custom-control-label {
  position: relative;
  margin-bottom: 0;
}

label {
  display: inline-block;
  margin-bottom: 0.5rem;
}

.labelbg {
  font-size:large;
  font-style: inherit;
  /* font-weight: bolder; */
}

.row.no-gutter [class*="col-"] {
  padding-right: 1px;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 0px 15px;
  margin-bottom: -1px;
  border: 1px solid #ddd;
  background-color: blue;
  line-height: 1em;
}

.col-lg-1>div {
  background-color: #ddd;
}

#docimg {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#line {
  border-top: 1px solid rgba(7, 14, 109, 0.25);
}

.test-modal .modal {
  padding: 0 !important;
  padding-left: 0px !important;
  overflow-y: scroll;
}

.test-modal .modal-dialog {
  max-width: 100%;
  height: 100%;
  margin: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  z-index: 100000;
  padding-right: 0px !important;
  padding-left: 0px !important;
}

.modal-open {
  padding: 0 !important;
  padding-left: 0px !important;
  overflow-y: scroll;
}

#phModal {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
</style>
